
var orderfilterHTML = `

    <div class="row" style="margin-top: 0px !important;">
      <div id="columnVisabilityContainer" class="col-sm-4 col-md-2" style="margin-top:22px">
      </div>

      <div class="form-group col-sm-4 col-md-2 offset-md-2">

      <label for="orderStatusFilter">Order Type Filter</label>
      <select class="form-control form-control-sm"
      style="margin-left: 0.5em; margin-right:1em;display:inline-block;" id="orderTypeFilter"
      placeholder="Filter Order Type">
        <option value="">All</option>
        <option value="smart post">Smart Post</option>
        <option value="sweep">Sweep</option>
        <option value="smart stop">Smart Stop</option>
      </select>
      </div>

      <div class="form-group col-sm-4 col-md-2">

      <label for="orderStatusFilter">Order Status Filter</label>
      <select class="form-control form-control-sm"
      style="margin-left: 0.5em; margin-right:1em;display:inline-block;" id="orderStatusFilter"
      placeholder="Filter Order Status">
        <option value="">All</option>
        <option value="open">Open</option>
        <option value="open-pending">Open (pending)</option>
        <option value="open-crashed">Open (crashed)</option>
        <option value="error">Error</option>
        <option value="closed">Closed</option>
        <option value="cancelled">Cancelled</option>
        <option value="cancelled-pending">Cancelled (pending)</option>
      </select>
      </div>

      <div id="client_orders_filter" class="form-group col-sm-4 col-md-2">

        <label for="sorOrderSearch">Search</label>
        <input type="search" id="orderSearch" class="form-control form-control-sm"
        placeholder="" aria-controls="client_orders">
      </div>

    </div>
    `

function orderLink(data,type,row) {
      return `<a href='/portal/orders/client/${row.client_order_id}/' class="table-link">${data}</a>`
}
class OrderListTable extends DataTable {


  constructor(table_id, run_setup) {
    super(table_id, false);
    this.serverSide = true;
    if(run_setup) {
      this.setupTable();

    }
    this.addStatusSearchEvent=false; // we don't need to search on status change, just trigger a reload
    this.addOrderFilters(orderfilterHTML);
    self = this
    $('#orderSearch').on('keyup', function() {
      self.table.search( this.value ).draw();
    })

    $('#orderTypeFilter').on('change', function () {
          self.refresh();
          });

  }

  _getTableAjax() {
    return {url: "/api/datatables/client_orders/?format=datatables",
            data: function(d) {
              d.order_status = $('#orderStatusFilter').val();
              d.order_type = $('#orderTypeFilter').val();
            }
    }
  }
  ordering() {

      return [[ 1, "desc" ]]

  }


  rowCallback(row, data) {



    if (data.order_status_state=="Open") {
      if (data.order_type=="smart stop" & !row.stop_triggered) {
        $(row).addClass('table-info');

      } else {
        $(row).addClass('table-success');

      }
    }
    else if (data.order_status_state=="Open (pending)") {
      $(row).addClass('table-warning');
    } else if (data.order_status_state=="Open (crashed)") {
      $(row).addClass('table-danger');
    }
    else if (data.order_status_state=="Cancelled (pending)") {
      $(row).addClass('table-warning');
    }
    else if (data.order_status_state=="Error") {
      $(row).addClass('table-danger');

    }
    $(row).click(function() {
      window.open(`/portal/orders/client/${data.client_order_id}/`,"_self");
    })
  }
  getTableColumns() {
    var columnArray = [
                { "data": "currency_pair.slug",
                },
                { "data": "created_at", "sortable": true,
                  "render": function(data, type, row) {
                    if (type === 'sort') {
                      return data
                    }
                    if(data) {
                        return moment(data).format('llll')
                      }
                    return moment(row.exchange_timestamp).format('llll')
                  }},

                {"data": "client_order_id"},

                {"data": "side"},

                { "data": "quantity", "searchable": false,
                  "render": function(data, type, row) {
                    var qty = Number(parseFloat(data).toFixed(8))
                    if (row.use_funding_currency) {
                      return `${qty} (${row.currency_pair.slug.split('-')[1]})`
                    } else {
                      return `${qty} (${row.currency_pair.slug.split('-')[0]})`

                    }
                  }},
                { "data": "executed_qty", "searchable": false,
                    "render": function(data, type, row) {
                      return Number(parseFloat(data).toFixed(8))
                    } },
                {"data": "remaining_qty",
                  "searchable": false,
                  "render": function(data, type, row) {
                    return Number(parseFloat(data).toFixed(8))
                  }
                },
                {"data": "pct_executed",
                "render": function(data, type, row) {
                  return Number(parseFloat(data).toFixed(2))
                }},

                { "data": "limit_price", "searchable": false,
                  "render": function(data, type, row) {
                    return Number(parseFloat(data).toFixed(8))
                  } },
                {"data": "order_type",
                "render": function(data, type, row) {
                  if(data == "smart stop") {
                    if(row.stop_triggered) {
                      return "smart stop (triggered)"
                    } else {
                      return "smart stop (untriggered)"
                    }
                  }
                  return data
                }
              },


                { "data": "avg_price", "searchable": false,
                    "render": function(data, type, row) {
                      return Number(parseFloat(data).toFixed(6))
                    }},

                { "data": "gross_consideration", "searchable": false,
                  "render": function(data, type, row) {
                    return Number(parseFloat(data).toFixed(6))
                  }},
                { "data": "net_consideration", "searchable": false,
                  "render": function(data, type, row) {
                    return Number(parseFloat(data).toFixed(6))
                  }},
                  { "data": "owner.email",
                    "render": function(data, type, row) {
                      if (type === 'sort') {
                        return data
                      }
                      return `<a href="#" onClick="$('#orderSearch').val('${data}'); $('#orderSearch').keyup();">${data}</a>`
                    }
                  },

                { "data": "order_status_state",
                    "name": "order_status",
                    "render": function(data, type, row) {
                      if (type=="sort" || type=="filter") {
                        return row.order_status
                      }
                      return data
                    },
                  },

                  {"data": "parent_order",
                  "name": "parent_order.client_order_id"},



            ]

            return columnArray
          }

}
